import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {detailsPagePushGaThunk} from '@stencil/hotels-ga/src';
import {DetailsGAClickEventActions} from '@stencil/hotels-config/src/config/ga-config';

import * as S from './styles/DealsDiscoveryModal.styles';
import {SmoothBehaviorOptions} from 'smooth-scroll-into-view-if-needed';
import {appConfig} from '@stencil/hotels-config';

import {defaultTheme} from '@stencil/build-theme';

import HappyCloseIcon from '@stencil/icons/src/HappyCloseIcon/HappyCloseIcon';
import {
  BaseColumnWrap,
  CenteredSpaceWrap,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

// import HappyFlashIcon from "StencilIcon/src/HappyFlashIcon/HappyFlashIcon";
import HappyOfferIcon from '@stencil/icons/src/HappyOfferIcon/HappyOfferIcon';

import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {
  detailsClick,
  DetailsPageComponents,
} from '@stencil/omniture-analytics/src/constants/details';
import {getPriceIntoCommaSeparatedString} from '@stencil/hotels-utils/src/common-utils';

const noop = () => {};

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3.4,
  slidesToScroll: 1,
};

const scrollOptions: SmoothBehaviorOptions = {
  behavior: 'smooth',
  inline: 'start',
  block: 'nearest',
};

const DealsDiscoveryModal = ({
  closeModal = noop,
  // offerData = {},
  bankDealsData = [],
  activeBankCode = '',
  offersPersuasions = {},
  priceInfo = {},
  // showPrice,
  // slashedPrice,
  // tnc,
  onPromoCodeSelection = code => {},
  // isOfferLoading = false,
  // isHermesDataLoading = false,
  bankPromoCount = 0,
}) => {
  const dispatch = useDispatch();
  // const isLoading = isHermesDataLoading || isOfferLoading;
  // if (!offerData || !offerData?.data || isOfferLoading) {
  //   return null;
  // }

  const priceInfo_DA = getPriceIntoCommaSeparatedString(priceInfo?.discount?.amount);
  const priceInfo_ShowPrice = getPriceIntoCommaSeparatedString(priceInfo?.showPrice);
  const priceInfo_Tnc = getPriceIntoCommaSeparatedString(priceInfo?.tnc);

  return (
    <>
      <S.DealsDiscoveySectionHeader>
        <S.HeaderPara>Offers Applied</S.HeaderPara>
        <HappyCloseIcon
          height="2rem"
          width="2rem"
          fill={defaultTheme.colors.downriver.base}
          onClick={closeModal}
        ></HappyCloseIcon>
      </S.DealsDiscoveySectionHeader>
      <S.DealsDiscoveryBodyWrap>
        {offersPersuasions?.goTribeOffer?.map(item => {
          return (
            <S.GoTribe_Wrap>
              <CenteredSpaceWrap>
                <S.GoTribe_Img src={item?.topLeftPersuasion?.imageUrl} />
                <S.Green_Amount>- {item?.price}</S.Green_Amount>
              </CenteredSpaceWrap>
              <div>
                <S.Additional_Text>{item?.secondaryText}</S.Additional_Text>
                {!!item?.additionalText.length &&
                  item?.additionalText.map(text => (
                    <S.DiscountAdditionalTextBlock>{text}</S.DiscountAdditionalTextBlock>
                  ))}
              </div>
            </S.GoTribe_Wrap>
          );
        })}

        {offersPersuasions?.specialOffer?.map(item => {
          return (
            <S.GoTribe_Wrap>
              <CenteredSpaceWrap>
                <S.DiscountTagBlock
                  bgColor={item?.topLeftPersuasion?.bgColor}
                  textColor={item?.topLeftPersuasion?.textColor}
                  borderColor={item?.topLeftPersuasion?.borderColor}
                >
                  {item?.topLeftPersuasion?.imageUrl && (
                    <S.OfferImgWrap src={item?.topLeftPersuasion?.imageUrl} />
                  )}
                  {item?.topLeftPersuasion?.text}
                </S.DiscountTagBlock>
                <S.Green_Amount>- {item?.price}</S.Green_Amount>
              </CenteredSpaceWrap>
              <CenteredSpaceWrap>
                <div>
                  <p>{item?.secondaryText}</p>
                  {!!item?.additionalText.length &&
                    item?.additionalText.map(text => (
                      <S.DiscountAdditionalTextBlock>{text}</S.DiscountAdditionalTextBlock>
                    ))}
                </div>
              </CenteredSpaceWrap>
            </S.GoTribe_Wrap>
          );
        })}

        {offersPersuasions?.loggedInOffer?.map(item => {
          return (
            <S.GoTribe_Wrap>
              <CenteredSpaceWrap>
                <S.DiscountTagBlock
                  bgColor={item?.topLeftPersuasion?.bgColor}
                  textColor={item?.topLeftPersuasion?.textColor}
                  borderColor={item?.topLeftPersuasion?.borderColor}
                >
                  {item?.topLeftPersuasion?.imageUrl && (
                    <S.OfferImgWrap src={item?.topLeftPersuasion?.imageUrl} />
                  )}
                  {item?.topLeftPersuasion?.text}
                </S.DiscountTagBlock>
                <S.Green_Amount>- {item?.price}</S.Green_Amount>
              </CenteredSpaceWrap>
              <CenteredSpaceWrap>
                <div>
                  <p>{item?.secondaryText}</p>
                  {!!item?.additionalText.length &&
                    item?.additionalText.map(text => (
                      <S.DiscountAdditionalTextBlock>{text}</S.DiscountAdditionalTextBlock>
                    ))}
                </div>
              </CenteredSpaceWrap>
            </S.GoTribe_Wrap>
          );
        })}
        <S.PromoCodeBody>
          <S.PromoCodeHeader>
            <HappyOfferIcon height="1rem" width="1rem" margin="0 0.5rem 0 0" fill="#FF6D38" />
            PROMOCODES ({bankPromoCount})
          </S.PromoCodeHeader>
          <S.PromoBank_Card>
            {bankDealsData?.map((item, index) => {
              const {coupons = []} = item;
              if (!coupons?.length) return;
              let isActive = activeBankCode
                ? coupons?.[0]?.code == activeBankCode
                : coupons?.[0]?.autoApplicable;
              return (
                <li
                  style={{
                    backgroundColor: isActive ? '#E9F6EA' : '',
                  }}
                  onClick={e => {
                    e.stopPropagation();
                    if (!isActive) {
                      onPromoCodeSelection(coupons?.[0]?.code);
                      dispatch(
                        omnitureThunk(
                          omnitureConfig.pages.DetailsUnif,
                          omnitureConfig.events.ctaClick,
                          {
                            cta: {
                              name: `${DetailsPageComponents.DealsDiscoveryModal}_${detailsClick.bankdeal.details_bank_offer_selected}_code=${coupons?.[0]?.code}|offer_rank=${index}`,
                              type: omnitureConfig.ctaType.Card,
                              componentName: DetailsPageComponents.DealsDiscoveryModal,
                              destination: '',
                            },
                          },
                        ),
                      );
                    }
                  }}
                >
                    <input type="radio" id="html" checked={isActive} />
                  <S.BankDetails_OuterWrap>
                    <S.PromoBankDetails>
                      <S.BankWrap isApplied={isActive}>
                        {!!coupons?.[0]?.promoIconLink && (
                          <S.SBI_Img src={coupons?.[0]?.promoIconLink} />
                        )}
                        {coupons?.[0]?.code}
                      </S.BankWrap>
                      <S.Final_Pricing isApplied={isActive}>
                        - {getPriceIntoCommaSeparatedString(coupons?.[0]?.couponAmount)}
                      </S.Final_Pricing>
                    </S.PromoBankDetails>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-end',
                      }}
                    >
                      <p
                        dangerouslySetInnerHTML={{
                          __html: isActive
                            ? `You saved ${getPriceIntoCommaSeparatedString(coupons?.[0]?.couponAmount)}`
                            : coupons?.[0]?.description,
                        }}
                      />
                    </div>
                  </S.BankDetails_OuterWrap>
                </li>
              );
            })}
          </S.PromoBank_Card>
        </S.PromoCodeBody>
      </S.DealsDiscoveryBodyWrap>
      <S.FotterBase>
        <BaseColumnWrap>
          {!!priceInfo?.discount?.amount && (
            <S.Total_saving_span>Total Savings</S.Total_saving_span>
          )}
          {!!priceInfo?.showPrice && (
            <>
              <S.Fianl_Price>Price after discount</S.Fianl_Price>
              <S.PerNight_Text>Per Night</S.PerNight_Text>
            </>
          )}
        </BaseColumnWrap>
        <S.Right_Side_Fotter>
          <>
            {!!priceInfo?.discount?.amount && (
              <S.Total_saving_Amount_span>- {priceInfo_DA}</S.Total_saving_Amount_span>
            )}
            {!!priceInfo?.showPrice && <S.Fianl_Price> {priceInfo_ShowPrice}</S.Fianl_Price>}
            {!!priceInfo?.tnc && <span>+ {priceInfo_Tnc} taxes & fees </span>}
          </>
        </S.Right_Side_Fotter>
      </S.FotterBase>
    </>
  );
};

export default DealsDiscoveryModal;
